import { makeStyles } from '@material-ui/core/styles';

import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  tag: {
    alignItems: 'center',
    backgroundColor: theme.colorPalette.beige_50,
    borderRadius: theme.spacing(8),
    fontSize: 12,
    fontWeight: 600,
    height: 24,
    padding: theme.spacing(1, 2),
    width: 'fit-content',
    ...reskinStyles(theme, theme.labelStyles.outlined)
  },
  internal: {
    backgroundColor: 'transparent',
    border: `1px dashed ${theme.colorPalette.green_75}`,
    borderRadius: theme.spacing(1),
    color: theme.colorPalette.green_75,
    fontSize: 10.5,
    fontWeight: 700,
    letterSpacing: '0.06em',
    lineHeight: 1.5,
    textTransform: 'uppercase',
    height: 'auto',
    padding: theme.spacing(0, 1.5),
    whiteSpace: 'nowrap'
  },
  tooltipAnchor: {
    display: 'inline-flex',
    verticalAlign: 'middle'
  }
});

export default makeStyles(styles);
